<template>
  <div v-loading="loading" element-loading-text="数据加载中..." style="height: 100%;width: 100%">
    <el-container style="height: 100%;width: 100%">
      <el-main style="padding: 0;width:100%;height: 100%;margin-left: 2px;overflow-x: hidden;overflow-y: hidden">
        <div style="display: flex;flex-direction: row;">
          <div style="margin-left: 5px;margin-top: 2px">
            <el-select style="width: 225px;" @change="clickThing" v-model="wujianId" filterable clearable
                       placeholder="物件名称">
              <el-option v-for="item in things" :key="item.id" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>

          <div class="border center"
               style="text-align: left;width: 100%;margin-left: 5px;height: 38px;overflow-y: auto;">
            <el-button size="small" class="week" style="margin-left: 10px" @click="clickThisWeek">{{ $t('makeSchedule.paintingProductionScheduling.thisWeek') }}</el-button>
            <el-button size="small" class="week" @click="clickLastWeek">
              <el-icon>
                <ElIconArrowLeft/>
              </el-icon>
              {{ $t('makeSchedule.paintingProductionScheduling.lastWeek') }}
            </el-button>
            <el-date-picker size="small" v-model="week" format="M月-D日" value-format="MM-DD" type="daterange"
                            disabled range-separator="~" style="width: 180px;"/>
            <el-button size="small" class="week" @click="clickNextWeek">{{ $t('makeSchedule.paintingProductionScheduling.afterWeek') }}
              <el-icon>
                <ElIconArrowRight/>
              </el-icon>
            </el-button>
            <span style="margin-left: 10px">{{ $t('makeSchedule.paintingProductionScheduling.version') }}：</span>
            <el-select v-model="versionIdx" style="width: 150px;" @change="queryCalendarLineData" filterable
                       :placeholder="$t('makeSchedule.paintingProductionScheduling.versionNumber')">
              <el-option v-for="item in versionIdxs" :key="item.id" :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
            <!--              <el-button size="small" style="width: 60px;margin-left: 10px" type="primary" :loading="versionIdxBool"-->
            <!--                         @click="queryCalendarLineData">查询-->
            <!--              </el-button>-->

            <span style="margin-left: 10px">
               <span style="background-color: rgb(103, 194, 58)">&nbsp;&nbsp;</span> <span>:正常</span>
            <span style="margin-left: 10px;background-color: red">&nbsp;&nbsp;</span> <span>:缺料</span>
              <span style="margin-left: 10px;color: #67c23a;">{{ $t('makeSchedule.AssemblyProductionScheduling.todayProduction') }}</span>/
              <span style="color: #f56c6c;">{{ $t('makeSchedule.AssemblyProductionScheduling.todayProductionScheduling') }}</span>/
              <span style="color: black;">{{ $t('makeSchedule.AssemblyProductionScheduling.yesterday') }}</span>/
              <span style="color: #909399;">{{ $t('makeSchedule.AssemblyProductionScheduling.batchNo') }}</span>
              </span>
            <el-button size="small" style="width: 60px;margin-left: 10px" type="warning" :loading="exportDataBool"
                       @click="exportAssemblyRecordData">导出
            </el-button>
          </div>

        </div>
        <div v-if="draggableBool" ref="total_height" style="display: flex;height: 95%;width: 100%;overflow-x: auto;">
          <!--            第一个-->
          <div class="total_style" v-for="item in state.dataList" :key="item">
            <div class="border color time">
              <div>{{ item.time }}</div>
              <div>{{ item.week }}</div>
            </div>
            <div v-if="!item.line_bool" :class="!item.line_bool?'prompt data_style1':''" :style="maxHeight">产线未开
            </div>
            <div v-if="item.line_bool" class="data_style">
              <div v-for="lineCnt in item.line_cnt" :key="lineCnt" class="data_style2">
                <div class="data_style3">
                  <span v-if="lineCnt.dayShiftCnt" class="data_style4">&nbsp;白{{ lineCnt.dayShiftCnt }}&nbsp;</span>
                  <span v-if="lineCnt.nightShiftCnt"
                        class="data_style4_1">&nbsp;夜{{ lineCnt.nightShiftCnt }}&nbsp;</span>
                </div>
                <div>
                  <draggable :style="lineCnt.height" :class="lineCnt.class_line_name" :list="lineCnt.lineData"
                             ghost-class="ghost" chosen-class="chosenClass" handle=".move" animation="300"
                             :sort="true" group="group">
                    <template #item="{ element }">
                      <div v-if="JSON.stringify(element) !== '{}'"
                           :class="element.is_material_shortage == false?'item1':'item2'"
                           :style="isBeforehandMaterialShortage?item3Style:''">
                        <el-row style="line-height: initial;">
                          <el-col :span="24">
                            <span>{{ element.wujian_name }}-</span>
                            <span>{{ element.scheduling_floor }}</span>
                          </el-col>
                          <div style="margin-top: -16px;margin-left: 92%;">
                                <span @click="materialDetailsClick(element,item.time,lineCnt)" class="cursor"
                                      style="font-size: 15px;"><el-icon><ElIconMoreFilled/></el-icon></span>
                          </div>
                        </el-row>
                        <div :class="element.is_material_shortage == false?'batchNoStyle1':'batchNoStyle1_1'"
                             style="border-top: #909399 1px solid;border-bottom: #909399 1px solid;">
                          <span>{{ element.batch_no }}</span>
                          <span style="color: #67c23a;margin-left: 35px;">{{ element.reality_num }}</span>
                          <span style="color: black">&nbsp;/&nbsp;</span>
                          <span style="color: #f56c6c">{{ element.plan_production_quantity }}&nbsp;</span>
                          <span style="color: black;">/&nbsp;{{ element.total_reality_num }}&nbsp;/&nbsp;</span>
                          <span style="color: #909399">{{ element.unit_num }}</span>
                        </div>
                        <el-tooltip class="custom-tooltip" :content="element.remark" placement="top">
                          <div v-if="element.remark" class="overflow-text" style="height: 100%;">备注：{{
                              element.remark
                            }}
                          </div>
                        </el-tooltip>
                      </div>
                    </template>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>

  <el-dialog title="计划详情" v-model="materialDetailsBool" width="45%">
    <el-form :model="formWujianData" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="物件番号：">
            <el-input v-model="formWujianData.wujian_id" disabled placeholder="物件番号" style="width: 90%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物件名称：">
            <el-input v-model="formWujianData.wujian_name" disabled placeholder="物件名称"
                      style="width: 90%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="楼层信息：">
            <el-input v-model="formWujianData.scheduling_floor" disabled placeholder="楼层信息"
                      style="width: 90%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="批号：">
            <el-input v-model="formWujianData.batch_no" disabled placeholder="批号" style="width: 90%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出荷日期：">
            <el-date-picker v-model="formWujianData.outbound_date" disabled type="date" placeholder="出荷日期"
                            style="width: 90%"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="排产日期：">
            <el-date-picker v-model="formWujianData.production_scheduling_date" disabled type="date"
                            placeholder="排产日期" style="width: 90%"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排产产线：">
            <div v-if="!lineBool" class="border"
                 style="width: 25px;height: 30px;line-height:30px;text-align: center;background-color: #0486fe;color: white;">
              {{ formWujianData.lineCnt }}
            </div> <!--  白班-->
            <div v-if="lineBool" class="border"
                 style="width: 25px;height: 30px;line-height:30px;text-align: center;background-color: #223342;color: white;">
              {{ formWujianData.lineCnt }}
            </div> <!--  夜班-->
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="单线日产量：">
            <el-input-number min="1" disabled v-model="formWujianData.line_production" placeholder="单线日产量"
                             style="width: 90%;"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="本计划数：">
            <el-input-number min="1" disabled v-model="formWujianData.plan_production_quantity" placeholder="本计划数"
                             style="width: 90%;"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="备注：">
            <el-input v-model="formWujianData.remark" rows="5" type="textarea" disabled placeholder="备注"
                      style="width: 95%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>
<script>
import draggable from "vuedraggable";
import moment from "moment";

export default {
  name: "assemblyProductionRecordScheduling",
  components: {draggable},
  data() {
    return {
      startDate: '',
      endDate: '',
      startTime: '',
      endTime: '',
      things: [],
      wujianId: '',
      versionIdx: '',
      versionIdxs: [],
      state: {
        dataList: [],
      },
      week: [], //时间组件数据
      weekList: [], //一个星期的时间
      materialDetailsBool: false, //控制物料详情页面
      lineBool: false,//false表示白班 true表示夜班
      loading: false,
      versionIdxBool: false,
      exportDataBool: false,
      draggableBool: false,
      item3Style:
          "border: solid 2px #0478e4 !important;" +
          "border-left: solid 3px #ffcc00 !important;" +
          "font-size: 12px;color: black;" +
          "margin-top: 3px;" +
          "height: 100%;" +
          "text-align: center;",
      isBeforehandMaterialShortage: false, //是否预缺料
      maxHeight: "",//获取页面的最大高度
    }
  }, methods: {
    getWuJianInFo() {
      this.$axios.post('mfg/wujianPlan/getWujianName').then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("获取数据失败");
        }

        this.things = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    async queryCalendarLineData() {
      if (!this.versionIdx) {
        return this.$message.error("版本号为空");
      }

      if (!this.wujianId) {
        return this.$message.error("物件为空");
      }

      if (!this.startTime) {
        return this.$message.error("开始时间为空");
      }

      if (!this.endTime) {
        return this.$message.error("结束时间为空");
      }

      if (!this.weekList) {
        return this.$message.error("week时间为空");
      }
      this.versionIdxBool = true
      this.draggableBool = true;
      this.loading = true;
      let params = {
        wujianId: this.wujianId,
        startTime: this.startTime,
        endTime: this.endTime,
        weekList: this.weekList,
        versionIdx: this.versionIdx
      };
      await this.$axios.post('mfg/assemblyProductionRecord/queryCalendarLineData', params).then(response => {
        this.loading = false;
        this.versionIdxBool = false
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        console.log("22222", res.data)
        this.state.dataList = res.data;
        setTimeout(() => {
          this.getMaxHeight();
        }, 200);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    exportAssemblyRecordData() {
      if (!this.versionIdx) {
        return this.$message.error("版本号不能为空");
      }

      this.exportDataBool = true;
      let params = {
        wujianId: this.wujianId,
        startTime: this.startTime,
        endTime: this.endTime,
        versionIdx: this.versionIdx
      };
      this.$axios.post('mfg/assemblyProductionRecord/exportAssemblyRecordData', params).then(response => {
        let res = response.data
        this.exportDataBool = false;
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }
        console.log("res:==", res)
        const url = res.data.url;
        const originalName = res.data.originalName;
        if (url) {
          const link = document.createElement('a');
          link.href = url;
          link.download = originalName || '' // 下载文件的名字
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }
        return this.$message.success("导出成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    async getVersionIdx() {
      if (!this.wujianId) {
        return this.$message.error("物件为空");
      }

      if (!this.startTime) {
        return this.$message.error("开始时间为空");
      }

      if (!this.endTime) {
        return this.$message.error("结束时间为空");
      }
      this.versionIdx = '';
      this.versionIdxBool = true;
      let params = {wujianId: this.wujianId, startTime: this.startTime, endTime: this.endTime};
      await this.$axios.post('mfg/assemblyProductionRecord/getVersionIdx', params).then(response => {
        this.loading = false;
        this.versionIdxBool = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        if (!res.data) {
          this.versionIdxs = res.data;
          this.$message.error("未找到版本号");
        } else {
          console.log("getVersionIdx=", res)
          this.versionIdxs = res.data;
          this.versionIdx = this.versionIdxs[this.versionIdxs.length - 1].value
          return this.$message.success("版本号查询成功");
        }

      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    //物件计划详情
    materialDetailsClick(element, time, lineCnt) {
      this.materialDetailsBool = true;
      this.formWujianData = element;
      let cnt;
      if (lineCnt.dayShiftCnt) {
        cnt = lineCnt.dayShiftCnt;
        this.lineBool = false;
      } else {
        cnt = lineCnt.nightShiftCnt;
        this.lineBool = true;
      }

      this.formWujianData.form_className = lineCnt.class_line_name;
      this.formWujianData.lineCnt = cnt;
      this.formWujianData.floor = element.scheduling_floor;
      let timeString = time.toString().substring(0, time.toString().length - 1);
      let timeList = timeString.toString().split("月");
      let month = timeList[0];
      let day = timeList[1];
      if (month < 10) {
        month = '0' + month;
      }

      if (day < 10) {
        day = '0' + day;
      }

      let date;
      //特殊处理跨年的
      if (this.startTime.substring(0,4) !== this.endTime.substring(0,4)) {
        if (parseInt(month) < 12) { //这是下一年
          date = this.endTime.substring(0,4) + '-' + month + '-' + day;
        } else {
          date = this.startTime.substring(0,4) + '-' + month + '-' + day;
        }
      } else {
        date = this.startTime.substring(0,4) + '-' + month + '-' + day;
      }
      this.formWujianData.production_scheduling_date = date;
      //console.log("formWujianData==", this.formWujianData)
    },
    async clickThing() {
      this.draggableBool = false;
      this.versionIdx = '';
      await this.getVersionIdx();
      await this.queryCalendarLineData();
    },
    //本周
    async clickThisWeek() {
      let obj = this.getCurrWeekDays();
      this.formatTime(obj.startTime, obj.endTime);
      this.draggableBool = false;
      await this.getVersionIdx();
      await this.queryCalendarLineData()
    },
    //上周
    async clickLastWeek() {
      let obj = this.getLastWeekDays(this.startTime, this.endTime);
      this.formatTime(obj.startTime, obj.endTime);
      this.draggableBool = false;
      await this.getVersionIdx();
      await this.queryCalendarLineData()
    },
    //下周
    async clickNextWeek() {
      let obj = this.getBelowWeekDays(this.startTime, this.endTime);
      this.formatTime(obj.startTime, obj.endTime);
      this.draggableBool = false;
      await this.getVersionIdx();
      await this.queryCalendarLineData()
    },
    // 获取本周开始结束时间
    getCurrWeekDays() {
      let obj = {
        startTime: '',
        endTime: ''
      }

      let endDate = new Date(this.assemblyEndTime); // 结束日期
      obj.startTime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD HH:mm:ss');
      obj.endTime = moment(endDate.valueOf()).format('YYYY-MM-DD HH:mm:ss');
      return obj
    },
    // 获取上一周的开始结束时间
    getLastWeekDays(startTime, endTime) {
      let obj = {
        startTime: '',
        endTime: ''
      }
      obj.startTime = moment(startTime).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss');
      obj.endTime = moment(endTime).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss');
      return obj
    },
    // 获取下一周的开始结束时间
    getBelowWeekDays(startTime, endTime) {
      let obj = {
        startTime: '',
        endTime: ''
      }
      obj.startTime = moment(startTime).add(7, 'days').format('YYYY-MM-DD HH:mm:ss');
      obj.endTime = moment(endTime).add(7, 'days').format('YYYY-MM-DD HH:mm:ss');
      return obj
    },
    //处理时间
    formatTime(startTime, endTime) {
      console.log("startTime=", startTime)
      console.log("endTime=", endTime)
      this.startTime = startTime;
      this.endTime = endTime;
      this.week = [];
      this.weekList = [];
      let startDate = new Date(startTime); // 开始日期
      let endDate = new Date(endTime); // 结束日期
      //let startYarn = startDate.getFullYear();//开始年
      let startMonth = startDate.getMonth() + 1; //开始月
      //let startDay = startDate.getDay(); //开始星期几
      let startCount = startDate.getDate(); //开始多少号
      //let endYarn = endDate.getFullYear();//结束年
      let endMonth = endDate.getMonth() + 1; //结束月
      //let endDay = endDate.getDay(); //结束星期几
      let endCount = endDate.getDate(); //结束多少号
      let weeks = ["一", "二", "三", "四", "五", "六", "日"]
      //本月
      if (startMonth == endMonth) {
        for (let i = startCount; i <= endCount; i++) {
          let time = startMonth + "月" + i + "日";
          this.weekList.push({time});
        }
        //上个月
      } else if (startMonth < endMonth) {
        let upLastDay = moment(startMonth).month(startMonth - 1).date(1).endOf("month")
            .format("YYYY-MM-DD").substring(8, 10);
        for (let i = startCount; i <= upLastDay; i++) {
          let time = startMonth + "月" + i + "日";
          this.weekList.push({time});
        }

        for (let i = 1; i <= endCount; i++) {
          let time = endMonth + "月" + i + "日";
          this.weekList.push({time});
        }
      }
      let cnt = 0;
      for (let i = 0; i < this.weekList.length; i++) {
        if (i === 7) {
          cnt = 0;
        }
        this.weekList[i]['week'] = "(" + weeks[cnt] + ")";
        cnt += 1;
      }

      if (startMonth < 10) {
        startMonth = "0" + startMonth;
      }

      if (startCount < 10) {
        startCount = "0" + startCount;
      }

      if (endMonth < 10) {
        endMonth = "0" + endMonth;
      }

      if (endCount < 10) {
        endCount = "0" + endCount;
      }
      this.startDate = startMonth + "-" + startCount;
      this.endDate = endMonth + "-" + endCount;
      this.week.push(this.startDate);
      this.week.push(this.endDate);
      // console.log(startTime)
      // console.log(endTime)
      // console.log(this.weekList)
    },
    getAssemblyEndTime() {
      let startTime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
      let endTime = moment(moment().week(moment().week()).endOf('week').add(8, 'days').valueOf()).format('YYYY-MM-DD');
      let params = {startTime: startTime, endTime: endTime};
      this.$axios.post('mfg/assemblyProduction/getAssemblyEndTime', params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("组立最后排产时间为空");
        }

        this.assemblyEndTime = res.data;
        console.log("assemblyEndTime=", this.assemblyEndTime)

        let obj = this.getCurrWeekDays();
        this.formatTime(obj.startTime, obj.endTime);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getMaxHeight() {
      var h_max = 0;
      var widthBox = document.getElementsByClassName('data_style');
      for (var i = 0; i < widthBox.length; i++) {
        if (h_max < widthBox[i].clientHeight) {
          h_max = widthBox[i].clientHeight;
        }
      }

      let totalHeight = this.$refs.total_height.clientHeight;
      let timeHeight = totalHeight * 0.06;
      console.log("this.totalHeight=", totalHeight)
      console.log("this.timeHeight=", timeHeight)
      let pageHeight = totalHeight - timeHeight - 15;
      if (h_max < pageHeight) {
        h_max = pageHeight;
      }

      console.log(pageHeight);
      this.maxHeight = "height: " + h_max + "px;";
      console.log("this.maxHeight=", this.maxHeight)
    },
  }, created() {
    this.getAssemblyEndTime();
    this.getWuJianInFo();
  }
}
</script>

<style scoped>
.border {
  border: rgb(216, 220, 230) 1px solid;
}

.color {
  background-color: rgb(228, 231, 237);
}

.center {
  text-align: center;
  height: 37px;
  line-height: 37px;
}

.cursor {
  cursor: pointer;
}

/*一下是拖拽样式*/
.item1 {
  border: solid 2px #0478e4 !important;
  border-left: solid 3px rgb(103, 194, 58) !important;
  font-size: 14px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
}

.item2 {
  border: solid 2px #0478e4 !important;
  border-left: solid 3px red !important;
  font-size: 14px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
}

.chosenClass {
  font-size: 13px;
  font-weight: bold;
}

/*button样式*/
.button {
  color: white;
  border-radius: 5px 5px 0 0;
  width: 100%;
  margin-top: 5px;
}

/*div样式*/
.week {
  border: #909399 0 solid;
  background-color: white;
  color: rgb(4, 134, 254);
}

.total_style {
  width: auto;
  align-items: center;
  margin-left: 5px;
  margin-top: 1px;
}

.time {
  width: 100%;
  text-align: center;
  margin-top: 5px;
}

.data_style {
  width: 224px;
  height: auto;
}

.data_style1 {
  width: 224px;
  height: auto;
  background-color: #e7e7e7;
  margin-top: 5px;
  border: rgb(216, 220, 230) 2px solid;
}

.data_style2 {
  margin-top: 5px;
  border: rgb(216, 220, 230) 2px solid;
}

.data_style3 {
  width: 100%;
  background-color: rgb(228, 231, 237);
  color: white;
  text-align: center;
  height: 30px;
  line-height: 30px;
}

.data_style4 {
  background-color: rgb(4, 120, 228);
  font-size: 14px;
}

.data_style4_1 {
  background-color: black;
  margin-left: 2px;
  font-size: 12px;
}

.data_style6 {
  margin-left: 45px;
  color: black;
}

.data_style7 {
  color: rgb(144, 147, 153);
}


/*动态样式*/
.batchNoStyle1_1 {
  color: red
}

.batchNoStyle1 {
  color: rgb(4, 120, 228)
}

.scrollbar::-webkit-scrollbar {
  display: none;
}

.prompt {
  color: rgba(0, 0, 0, 0.2);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.overflow-text {
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 显示省略号 */
  width: 100%; /* 设置容器的宽度 */
  position: relative; /* 为悬停时显示的提示框做准备 */
}

.custom-tooltip {
  width: 150px; /* 设置提示框的宽度 */
  max-height: 200px; /* 设置提示框的最大高度 */
  overflow-y: auto; /* 如果内容超出高度，显示滚动条 */
}


</style>